// extracted by mini-css-extract-plugin
export default {"certificate-details__container":"Details_certificate-details__container__UwHUI","title__section":"Details_title__section__WfWRZ","details-value":"Details_details-value__Dg1NX"};